/* ─────────────────────────────────────────────────────────────────────────────
   PGA Yorkshire — Card 3D Tilt on Hover
   ─────────────────────────────────────────────────────────────────────────────

   HOW TO USE
   ──────────
   Add data-tilt to any card element. The card will tilt toward the cursor
   as you hover, creating a physical depth effect.

     <div class="my-card" data-tilt>...</div>

   Options (all optional):
     data-tilt-max="8"        max tilt angle in degrees (default 7)
     data-tilt-scale="1.03"   scale on hover (default 1.03)
     data-tilt-speed="400"    return-to-flat transition in ms (default 500)

   Automatically disabled for prefers-reduced-motion users.
──────────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var PERSPECTIVE  = 900;   /* px — higher = flatter perspective */
  var DEFAULT_MAX  = 7;     /* degrees */
  var DEFAULT_SCALE = 1.03;
  var EASE_IN  = 'transform 0.12s ease';
  var EASE_OUT = 'transform 0.5s cubic-bezier(0.23, 1, 0.32, 1)';

  function setup(el) {
    if (el._tiltInit) return;
    el._tiltInit = true;

    var maxTilt = parseFloat(el.dataset.tiltMax)   || DEFAULT_MAX;
    var scale   = parseFloat(el.dataset.tiltScale)  || DEFAULT_SCALE;
    var raf     = null;
    var rotX    = 0;
    var rotY    = 0;

    el.style.willChange = 'transform';

    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      /* Normalise cursor to -0.5 … +0.5 within the card */
      var nx = (e.clientX - rect.left)  / rect.width  - 0.5;
      var ny = (e.clientY - rect.top)   / rect.height - 0.5;
      rotY   =  nx * maxTilt * 2;   /* left/right tilt */
      rotX   = -ny * maxTilt * 2;   /* up/down tilt (inverted) */

      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        el.style.transition = EASE_IN;
        el.style.transform  =
          'perspective(' + PERSPECTIVE + 'px) ' +
          'rotateX('     + rotX.toFixed(2) + 'deg) ' +
          'rotateY('     + rotY.toFixed(2) + 'deg) ' +
          'scale('       + scale + ')';
      });
    });

    el.addEventListener('mouseleave', function () {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      el.style.transition = EASE_OUT;
      el.style.transform  =
        'perspective(' + PERSPECTIVE + 'px) rotateX(0deg) rotateY(0deg) scale(1)';
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-tilt]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.CardTilt = { refresh: init };
})();
